Monitoring.Views ||= {}

class Monitoring.Views.MovistarRuleGeneralEditView extends Backbone.View
  template: JST["backbone/templates/monitoring/movistar_rules/movistar_rule_general_edit"]

  events:
    'change #rule-name': 'onChangeName'
    'change #rule-description': 'onChangeDescription'
    'change #rule-active': 'onChangeActive'

  initialize: (@options = {}) ->
    @rule = @options.rule

  render: =>
    @$el.html(@template(@))
    @initializeToggle()
    @

  initializeToggle: ->
    @$el.find('#rule-active').bootstrapToggle({
      onstyle: 'success'
      offstyle: 'warning'
    })

  onChangeName: (evt) ->
    @onChangeTextProperty('name')
    @trigger('changed-mandatory-field')

  onChangeDescription: (evt) ->
    @onChangeTextProperty('description')
    @trigger('changed-mandatory-field')

  onChangeTextProperty: (propertyName) ->
    enteredProperty = @$el.find("#rule-#{propertyName.replace('_', '-')}").val().trim()
    @rule.set(propertyName, enteredProperty)

  allMandatoryFieldsAreFilled: =>
    @nameIsFilled()

  nameIsFilled: ->
    @$el.find('#rule-name').val().trim().length > 0



